import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const SwimmingPool = () => {
  const [activeImage, setActiveImage] = useState(0);

  const facilityData = {
    name: 'Swimming Pool',
    category: 'Sports',
    description: 'Olympic-size swimming pool with separate kids pool.',
    longDescription: 'Dive into luxury at our Olympic-size swimming pool, perfect for serious swimmers and casual bathers alike. The main pool features lap lanes for training, while a separate children\'s pool ensures safe fun for the little ones. Surrounded by comfortable loungers and lush landscaping, it\'s the ideal spot to relax and cool off.',
    images: [
      getImagePath('images/bars/swimming-pool.jpg'),
      getImagePath('images/bars/swimming-pool.jpg'),
      getImagePath('images/bars/swimming-pool.jpg')
    ],
    icon: 'fa-swimmer',
    capacity: '100 swimmers',
    hours: 'Daily: 6am - 8pm',
    features: [
      'Olympic-size Pool',
      'Heated Pool',
      'Kids Pool',
      'Lap Lanes',
      'Diving Board',
      'Poolside Loungers',
      'Showers & Changing',
      'Lifeguards on Duty'
    ],
    amenities: ['Towel Service', 'Poolside Bar', 'Shaded Areas', 'Lockers'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'swimming@nlngraclub.com',
      extension: '112'
    },
    classes: ['Swimming Lessons', 'Aqua Aerobics', 'Lap Swimming', 'Kids Classes'],
    events: ['Pool Parties', 'Swim Meets', 'Family Swim Nights']
  };

  return (
    <div className="facility-detail-page">
      {/* Hero Section */}
      <section className="facility-detail-hero">
        <div className="hero-background">
          <img src={facilityData.images[0]} alt={facilityData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/facilities" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Facilities
            </Link>
            <span className="facility-category">{facilityData.category}</span>
            <h1 className="facility-title">{facilityData.name}</h1>
            <p className="facility-subtitle">{facilityData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Facility Content */}
      <section className="facility-content-section">
        <div className="container">
          <div className="facility-grid">
            {/* Left Column - Images */}
            <div className="facility-gallery">
              <div className="main-image">
                <img 
                  src={facilityData.images[activeImage]} 
                  alt={facilityData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {facilityData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${facilityData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="facility-details">
              <div className="detail-section">
                <h2>About {facilityData.name}</h2>
                <p className="facility-description">{facilityData.longDescription}</p>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {facilityData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="info-grid">
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <h4>Hours</h4>
                  <p>{facilityData.hours}</p>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <h4>Capacity</h4>
                  <p>{facilityData.capacity}</p>
                </div>
                <div className="info-card">
                  <i className="fas fa-phone"></i>
                  <h4>Contact</h4>
                  <p>{facilityData.contact.phone} ext. {facilityData.contact.extension}</p>
                </div>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Classes:</span>
                  <span className="info-value">{facilityData.classes.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Events:</span>
                  <span className="info-value">{facilityData.events.join(' • ')}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/login" className="btn btn-primary btn-large">
                  <i className="fas fa-calendar-check"></i> Book Swim Time
                </Link>
                <Link to="/contact" className="btn btn-outline btn-large">
                  <i className="fas fa-envelope"></i> Swimming Lessons
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SwimmingPool;